import React, { useContext } from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
const DevpageSidebarPlacement = ()=>{
    const { isLoggedIn } = useContext(SessionContext);
    // User
    if (isLoggedIn) {
        return /*#__PURE__*/ React.createElement(BannerAdUnit, {
            width: "308px",
            height: "316px",
            realEstateId: "8705520c-14b7-48a0-b681-766bab417d53"
        });
    }
    // Anon
    return /*#__PURE__*/ React.createElement(BannerAdUnit, {
        width: "308px",
        height: "316px",
        realEstateId: "b912510c-e850-43c0-bcf6-50e1674f0c2c"
    });
};
DevpageSidebarPlacement.displayName = 'DevpageSidebarPlacement';
export default DevpageSidebarPlacement;
